<template>
  <div ref="input-ctn" class="input-ctn">
    <input
      ref="input"
      class="input"
      :class="{'input--error': error}"
      type="text"
      :value="value"
      @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'text')"
      @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
      @input="reemitEvent('input', $event)"
      @blur="reemitEvent('blur', $event)"
    >
    <div ref="dots-ctn" class="dots-ctn" />
  </div>
</template>

<script>
import { gsap, Power0 } from 'gsap'
import { mapState } from 'vuex'

const DOT_DIMENSION = 4
const DOT_MARGIN = 6

export default {
  name: 'ContactInput',
  props: {
    value: String,
    error: Boolean
  },
  computed: {
    ...mapState(['vWidth'])
  },
  methods: {
    reemitEvent (eventName, eventObject) {
      this.$emit(eventName, eventObject.target.value)
    },
    animateDots (hasError) {
      const dots = this.$refs['dots-ctn'].childNodes
      gsap.timeline()
        .to(
          dots,
          {
            y: '5px',
            ease: Power0.easeNone,
            duration: 0.05,
            stagger: {
              repeat: 1,
              yoyo: true,
              each: 0.03
            }
          },
          'dots-down'
        )
        .to(
          dots,
          {
            backgroundColor: hasError ? '#e3342f' : 'black',
            ease: Power0.easeNone,
            duration: 0.05,
            stagger: 0.03
          },
          'dots-down'
        )
    },
    addDotsToContainer () {
      const dotsContainer = this.$refs['dots-ctn']
      while (dotsContainer.firstChild) dotsContainer.removeChild(dotsContainer.lastChild)
      const dotsContainerWidth = dotsContainer.getBoundingClientRect().width
      const dotsAmountToAdd = parseInt(dotsContainerWidth / (DOT_DIMENSION + DOT_MARGIN) + 1)
      for (let i = 1; i <= dotsAmountToAdd; i++) {
        const dot = document.createElement('div')
        dot.classList.add('input-dot') // class has to be defined globally due componente encapsulation (see src/globals.sass)
        dotsContainer.appendChild(dot)
      }
    }
  },
  watch: {
    error (hasError) {
      this.animateDots(hasError)
    },
    vWidth () {
      this.addDotsToContainer()
    }
  },
  mounted () {
    this.addDotsToContainer()
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .input-ctn
    @apply relative inline-block
    bottom: 3px

  .input
    @apply text-xl font-light italic bg-transparent w-full
    outline: none
    cursor: none
    @screen lg
      @apply text-3xl
    @screen xxl
      @apply text-4xl
    &--error
      @apply text-red

  .dots-ctn
    @apply absolute flex justify-between w-full h-2
    bottom: -6px
    @screen xxxl
      bottom: -3px
</style>
